import _typeof from "@babel/runtime/helpers/esm/typeof";

/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-27 13:46:55
 * @LastEditTime: 2021-01-06 11:33:09
 */
// ====loader 基本加载器
var loader = {
  /**
     * 加载脚本基础方法
     * @private
     * @param {string} filepath 路径
     * @param {function} callback 回调方法
     * @return {undefined} undefined
     */
  loadScript: function loadScript(url) {
    return new Promise(function (resolve, reject) {
      var head = document.head || document.getElementsByTagName('head')[0] || document.documentElement;
      var options = {};

      if (_typeof(url) === 'object') {
        options = url;
        url = options.url;
      } // options.timeout = options.timeout || 0; //0代表没有超时机制
      // callback = callback || s.success;


      var sRefresh = 0 === options.sRefresh ? '' : options.sRefresh || new Date().getTime();
      var script = document.createElement('script');
      script.async = options.async || false;
      script.type = 'text/javascript';
      script.charset = options.charset || '';

      if (sRefresh) {
        url = "".concat(url + (/\?/.test(url) ? '&' : '?'), "_=").concat(sRefresh);
      }

      script.src = url;
      head.insertBefore(script, head.firstChild);
      var timeout;

      if (0 != options.timeout) {
        timeout = setTimeout(function () {
          if (script) {
            head.removeChild(script);
            script = null;
            reject({
              errCode: -999,
              errMsg: '网络请求超时',
              url: url
            });
          }
        }, options.timeout || 30000);
      }

      loader.onload(script, function () {
        if (script) {
          head.removeChild(script);
          script = null;
          clearTimeout(timeout);
          resolve(true);
        }
      });
    });
  },

  /**
     * 加载样式基础方法
     * 暂不处理加载的情况，均认为加载成功。
     * @private
     */
  loadCSS: function loadCSS(url, callback, id) {
    var head = document.getElementsByTagName('head')[0];
    var link = head.appendChild(document.createElement('link'));
    link.href = url;
    link.rel = 'stylesheet';

    if (id) {
      link.id = id;
    }

    callback.call(this, true);
  },
  loadCssText: function loadCssText(cssText) {
    var cssDom = document.createElement('style');
    cssDom.setAttribute('type', 'text/css');
    var textNode = document.createTextNode(cssText);
    cssDom.append(textNode);
    document.getElementsByTagName('head')[0].append(cssDom);
  },
  onload: function onload(node, callback) {
    var isImpOnLoad = 'onload' in node ? true : function () {
      node.setAttribute('onload', '');
      return typeof node.onload === 'function';
    }();

    if (document.addEventListener) {
      node.addEventListener('load', function () {
        callback.call(this, node);
      }, false);
    } else if (!isImpOnLoad) {
      node.attachEvent('onreadystatechange', function () {
        var rs = node.readyState.toLowerCase();

        if (rs === 'loaded' || rs === 'complete') {
          node.detachEvent('onreadystatechange');
          callback.call(this, node.innerHTML);
        }
      });
    } else {// maybe someother browser
    }
  }
};
export default loader;